import React, { createContext, useState, useCallback, ReactNode } from 'react';
import { LogInState, Role } from "../types";

interface AuthState {
  isLoggedIn: LogInState;
  role: Role;
  myUserId: number;
}

interface AuthContextValue extends AuthState {
  setLoggedIn: React.Dispatch<React.SetStateAction<LogInState>>;
  setRole: React.Dispatch<React.SetStateAction<Role>>;
  setMyUserId: React.Dispatch<React.SetStateAction<number>>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isLoggedIn, setLoggedIn] = useState<LogInState>(LogInState.AppLoading);
  const [role, setRole] = useState<Role>(Role.Unknown);
  const [myUserId, setMyUserId] = useState<number>(0);

  const logout = useCallback(() => {
    setLoggedIn(LogInState.NotLoggedIn);
    setRole(Role.Unknown);
    setMyUserId(0);
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, role, myUserId, setLoggedIn, setRole, setMyUserId, logout }}>
      {children}
    </AuthContext.Provider>
  );
};